import React from 'react';
import axios from 'axios';
import {ServiceLocator} from "../../Services/ServiceLocator";
import { v4 as uuid } from 'uuid';
import WorkshopTemplate from "./WorkshopTemplate";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";

import { AuthenticationService } from "../../Services/AuthenticationService";
import {getNumberInputDisplayValue, parseNumberInputValue} from '../../utils/numberInputUtils';
import { toUtcForStorage } from '../../utils/dateUtils';
let parts = [];

class SetInventory extends React.Component {
    state = {
        loading: true,
        savingLog: false,
        quantity: 0,
        originalQuantity: 0,
        reason: '',
        affectsSalesData: false
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const self = this;

        self.setState({loading: true});
        const partId = globalProps.match.params.partId;
        Promise.all([self.loadParts()]).then(() => {
            const part = parts.find(p => p.part.id === partId);
            if (part) {
                const originalQuantity = part.totalUnpackaged || 0;
                self.setState({
                    part: part.part, 
                    loading: false, 
                    quantity: originalQuantity,
                    originalQuantity: originalQuantity
                });
            } else {
                self.setState({loading: false});
            }
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((partsResult) => {
            parts = partsResult.sort(function (a, b) {
                if (a.part.partId < b.part.partId) return -1;
                if (a.part.partId > b.part.partId) return 1;
                return 0;
            });
            self.setState({parts});
        });
    };

    addInventoryLog = () => {
        const self = this;
        const parsedQuantity = parseNumberInputValue(this.state.quantity);
        if (parsedQuantity === 0 && this.state.quantity !== '0') {
            return window.$alertWarning("You must enter a quantity");
        }

        const newQuantity = parsedQuantity;
        const originalQuantity = this.state.originalQuantity;
        const delta = newQuantity - originalQuantity;

        if (delta === 0) {
            return window.$alertWarning("No change in quantity detected");
        }

        self.setState({savingLog: true});

        if (this.state.affectsSalesData === true) {
            // Sales log uses inverse of the inventory delta (stock decrease → positive sold qty).
            const salesQuantity = -delta;
            if (salesQuantity <= 0) {
                self.setState({savingLog: false});
                return window.$alertWarning("Sales projections require a stock decrease (new quantity must be lower).");
            }
            if (parsedQuantity < 0) {
                self.setState({savingLog: false});
                return window.$alertWarning("Inventory quantity cannot be negative.");
            }
            this.addSalesLog(parsedQuantity);
        } else {
            const payload = {
                id: uuid(),
                quantity: delta,
                partId: this.state.part.id,
                logDate: toUtcForStorage(new Date()),
                reason: this.state.reason.trim() ? `Set Inventory: ${this.state.reason}` : "Set Inventory"
            };
            
            const partService = ServiceLocator.Instance.getPartService();
            partService.createInventoryLog(payload).then(() => {
                window.$alertSuccess("Inventory set successfully");
                self.setState({savingLog: false, completed: true});
            }).catch((error) => {
                console.error('Error creating inventory log:', error);
                window.$alertError("Failed to set inventory");
                self.setState({savingLog: false});
            });
        }
    };

    addSalesLog = (parsedQuantity) => {
        const self = this;
        const newQuantity = parsedQuantity;
        const originalQuantity = this.state.originalQuantity;
        const delta = newQuantity - originalQuantity;
        const inverseDelta = -delta; // Inverse of the delta for sales log

        const payload = {
            id: uuid(),
            source: "Customer Service",
            orderNumber: "",
            logDate: toUtcForStorage(new Date()),
            assemblyId: null,
            partId: this.state.part.id,
            quantity: inverseDelta,
            reason: `Set Inventory${this.state.reason.length > 0 ? ': ' + this.state.reason : ''}`,
            userId: AuthenticationService.getInstance().getUserId(),
            affectsProjections: true,
            isManuallyAssigned: false,
            status: 'Fulfilled'
        };
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.importSalesLogs([payload]).then(() => {
            window.$alertSuccess("Inventory (Sales) set successfully");
            self.setState({savingLog: false, completed: true});
        }).catch((error) => {
            console.error('Error creating sales log:', error);
            window.$alertError("Failed to set inventory");
            self.setState({savingLog: false});
        });
    };

    render() {
        const self = this;
        if (this.state.loading) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <CircularProgress/>
                    </div>
                </WorkshopTemplate>
            );
        }

        const {part} = self.state;

        if (this.state.completed) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Inventory set successfully!</h2>
                        <Button onClick={() => globalProps.history.push(`/search/${part.id}`)}
                                      className="success-button-lg">Part Home</Button>
                        <br/><br/>
                    </div>
                </WorkshopTemplate>
            );
        }

        if (!part) {
            return (
                <WorkshopTemplate>
                    <div className="mobile-container">
                        <h2>Invalid URL</h2>
                    </div>
                </WorkshopTemplate>
            );
        }

        const delta = parseNumberInputValue(this.state.quantity) - this.state.originalQuantity;
        const deltaText = delta > 0 ? `+${delta}` : delta.toString();

        return (
            <WorkshopTemplate>
                <div className="mobile-container">
                    {part ?
                        <div>
                            <Button onClick={() => globalProps.history.push(`/search/${part.id}`)}
                                          className="success-button-lg">Part Home</Button>
                            <h2>Set Inventory<br/>{part.partId} rev {part.revision}</h2>
                        </div>
                        : ""}
                    
                    <div style={{marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px'}}>
                        <div style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '8px'}}>
                            Current Inventory: {this.state.originalQuantity}
                        </div>
                        <div style={{fontSize: '14px', color: '#666'}}>
                            Enter the new quantity you want to set
                        </div>
                    </div>

                    <TextField
                        placeholder="New Quantity"
                        label="New Quantity"
                        variant="outlined" 
                        inputProps={{inputMode: 'numeric'}}
                        onChange={(event) => this.setState({quantity: event.target.value})}
                        value={this.state.quantity || ''}
                        autoComplete="off"
                        style={{width: '100%', marginBottom: '20px'}}
                    />

                    {delta !== 0 && (
                        <div style={{
                            marginBottom: '20px', 
                            padding: '2px', 
                            backgroundColor: delta > 0 ? '#e8f5e8' : '#ffe8e8', 
                            borderRadius: '8px',
                            border: `2px solid ${delta > 0 ? '#4caf50' : '#f44336'}`
                        }}>
                            <div style={{fontSize: '16px', fontWeight: 'bold'}}>
                                Change: {deltaText}
                            </div>
                        </div>
                    )}

                    <TextField
                        placeholder="Reason (optional)"
                        label="Reason"
                        variant="outlined"
                        style={{width: '100%', marginBottom: '20px'}}
                        onChange={(event) => this.setState({reason: event.target.value})}
                        value={this.state.reason}
                        autoComplete="off"
                    />

                    <Tooltip title="If selected, this will log as a sale rather than an inventory adjustment, and reflect in projections." placement="bottom" TransitionComponent={Zoom}>
                        <div>
                            <Checkbox onClick={(event) => {
                                this.setState({affectsSalesData: event.target.checked})
                            }} checked={this.state.affectsSalesData}/> Should this affect sales projections?
                        </div>
                    </Tooltip>
                    <br/>

                    {this.state.savingLog === true ?
                        <CircularProgress/>
                        :
                        <Button 
                            label="Set Inventory" 
                            primary={true}
                            className="success-button-lg"
                            onClick={this.addInventoryLog}
                            disabled={delta === 0}
                            style={{width: '100%'}}
                        >
                            Set Inventory
                        </Button>
                    }
                    <br/><br/>
                </div>
            </WorkshopTemplate>
        );
    }
}

let globalProps;

export default SetInventory; 